export enum ActionType {
    EVAL_MAIN__RELOAD = 'EVAL_MAIN__RELOAD',
    EVAL_MAIN__RELOAD_RESULT = 'EVAL_MAIN__RELOAD_RESULT',
    EVAL_MAIN__SELECT_USER = 'EVAL_MAIN__SELECT_USER',
    EVAL_MAIN__SELECT_TEMPLATE_VERSION = 'EVAL_MAIN__SELECT_TEMPLATE_VERSION',
    EVAL_MAIN__RESET = 'EVAL_MAIN__RESET',
}
